export const forkConfig = {
  showBanner: false,
  pending: true,
  socials: false,
  latestSyncedBlockSupported: false,
  chartDataPending: false,
  enableTopBar: false,
}
